import { render, staticRenderFns } from "./SunGirl.vue?vue&type=template&id=89bc8d76&scoped=true&"
import script from "./SunGirl.vue?vue&type=script&lang=ts&"
export * from "./SunGirl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc8d76",
  null
  
)

export default component.exports